import React, { useState } from 'react';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="flex gap-11 px-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`py-4 text-base font-medium tracking-[0] leading-[normal] relative transition-colors ${
              activeTab === tab.id
                ? 'text-primary font-semibold '
                : 'text-textcolor hover:text-primary'
            }`}
          >
            {tab.label}
            {activeTab === tab.id && (
              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#06323A]" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
